import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  dialog: {
    width: '450px',
    boxShadow: '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    borderRadius: '4px',
  },
  title: {
    paddingTop: '24px',
    '&>h3': {
      fontSize: '18px',
      fontWeight: 600,
      letterSpacing: '0em',
      lineHeight: '27px',
      textAlign: 'left',
      color: theme.evPalette.charcoal[900],
      textTransform: 'none',
    },
  },
  contentText: {
    color: theme.evPalette.charcoal[700],
  },
  actions: {
    paddingBottom: '24px',
    paddingRight: '24px',
    paddingLeft: '24px',
    '&>button': {
      textTransform: 'none',
      fontSize: '16px',
    },
  },
}));
